import React from "react";
import MessageItem from "components/MessageItem";
// import './style.scss'

const Message = (props) => {
  return <MessageItem {...props} isReply={false} />;
};

export default Message;
